import { render, staticRenderFns } from "./WordButton.vue?vue&type=template&id=e5483f0c&"
import script from "./WordButton.vue?vue&type=script&lang=js&"
export * from "./WordButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports